shvenergy.testimonialvideo = (function ($) {
	"use strict";

	function init() {

        var testimonialvideos = $(".testimonial-video");
		var embed;
        var bynderVideoUrl;
        var videoProvider;

		testimonialvideos.each(function () {

			var items = $(this).find(".testimonial-video-item");
			var indicatorButtons = $(this).find(".indicator-button");
			var userHasInteracted = false;
			var interval;

			items.each(function() {

                embed = $(this).data("videoembedurl");
                bynderVideoUrl = $(this).data("videosourceurl");
                videoProvider = $(this).data("videotype");
				var trackingElement = $(this).find("blockquote").clone();
				trackingElement.find("span").remove();
				var trackingText = trackingElement.text().replace(/(\r\n|\n|\r)/gm, "").trim();

				var button = $(this).find(".video-play-button");
                button.data("videoembedurl", embed);
                button.data("videosourceurl", bynderVideoUrl);
                button.data("videotype", videoProvider);

				button.on("click", function (e) {
					e.stopPropagation();
                    var videoUrl = $(this).data("videoembedurl");
                    var bynderVideoUrl = $(this).data("videosourceurl");
                    var videoSourceProvider = $(this).data("videotype");
					var pageName = document.pageType == "Content page" ? document.title : document.pageType;

                    if (videoSourceProvider == "Bynder") {
                        shvenergy.byndervideoplayer.playbyndervideo(bynderVideoUrl);
                    }
                    else {
                        shvenergy.videoplayer.playvideo(videoUrl);
                    }
					shvenergy.tracking.trackEvent("Testimonial video", "Play video", trackingText);

					shvenergy.tracking.trackRawEventData({
						'event': 'clickVideo',
						'videoName': trackingText,
						'pagename': pageName
					});
				});

			});

			indicatorButtons.on("click", function (e) {
				e.stopPropagation();
				clearAutoadvance();

				if ($(this).hasClass("is-active"))
					return;

				var index = parseInt($(this).data("index"));
				setActiveItem(index);

			});


			function setActiveItem(index) {
				
				items.each(function () {
					var ci = $(this);
					if (ci.hasClass("is-active")) {
						ci.addClass("is-fadedout").removeClass("is-fadedin");
						setTimeout(function () {
							ci.removeClass("is-fadedout").removeClass("is-active");

							//now fade in the new one
							items.eq(index).addClass("is-active");
							setTimeout(function () {
								items.eq(index).addClass("is-fadedin");
							}, 10);

						}, 410);
					}
				});

				indicatorButtons.removeClass("is-active");
				indicatorButtons.eq(index).addClass("is-active");

			}

			function autoAdvance() {
				var currentButtonIndex = getCurrentIndicatorButtonIndex();

				if (currentButtonIndex === indicatorButtons.length - 1)
					currentButtonIndex = 0;
				else
					currentButtonIndex = currentButtonIndex + 1;


				setActiveItem(currentButtonIndex);

			}

			function getCurrentIndicatorButtonIndex() {
				var retVal = 0;
				var found = false;
				indicatorButtons.each(function () {
					if ($(this).hasClass("is-active") && !found) {
						retVal = parseInt($(this).data("index"));
						found = true;
					}
				});

				return retVal;
			}

			if (items.length > 1) {
				interval = setInterval(function() {
					autoAdvance();
				}, 6000);
			}

			
			function clearAutoadvance() {
				if (interval) {
					clearInterval(interval);
				}
			}




		});

    }

    init();

})(jQuery);